<template>
  <!-- greater than 1 page -->
  <ul
    v-if="numPages > 1"
    class="col-12 justify-content-start paginacao-setas mt-48"
  >
    <li
      class="mr-2 v-cursor-pointer v-prev-page"
      :class="{ 'v-disable-click': disablePrev }"
      @click="prevPage()"
    >
      <a href="#vue-app-busca"
        ><img
          class="mb-1"
          :src="`/static/novomundosenai/imgs/paginacao-seta-esquerda.svg`"
      /></a>
    </li>
    <li
      v-for="(value, index) in paginationArray"
      :key="index"
      class="v-cursor-pointer v-page"
      :class="{
        active: activeIndex(value),
        'v-disable-click': value === '...',
      }"
      @click="changePage(value)"
    >
      <a href="#vue-app-busca">{{ value }}</a>
    </li>
    <li
      class="pag-after v-cursor-pointer v-next-page"
      @click="nextPage()"
      :class="{ 'v-disable-click': disableNext }"
    >
      <a href="#vue-app-busca"
        ><img
          class="mb-1"
          :src="`/static/novomundosenai/imgs/paginacao-seta-esquerda.svg`"
      /></a>
    </li>
  </ul>
</template>

<script>
import { usePagination } from '@/composables/usePagination.js'
import { useSearch } from '@/composables/useSearch.js'
import { watch } from '@vue/runtime-core'
export default {
  setup() {
    let { numPages, currentPage } = useSearch()

    let {
      disablePrev,
      disableNext,
      loadPagination,
      activeIndex,
      changePage,
      prevPage,
      nextPage,
      paginationArray,
    } = usePagination()

    watch(numPages, function () {
      loadPagination()
    })

    watch(currentPage, function () {
      if (currentPage.value === 1 && numPages) {
        loadPagination()
      }
    })

    loadPagination()

    const staticPath = process.env.VUE_APP_STATIC_PATH

    return {
      paginationArray,
      currentPage,
      disablePrev,
      disableNext,
      activeIndex,
      changePage,
      prevPage,
      nextPage,
      staticPath,
      numPages,
    }
  },
}
</script>
